import { Card, CardContent } from "@design-lab/shared/ui/card";

interface LoaderProps {
  message?: string;
  className?: string;
  showCard?: boolean;
}

export function Loader({
  message = "Loading product data...",
  className = "",
  showCard = true
}: LoaderProps) {
  const content = (
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="h-12 w-12 rounded-full border-4 border-gray-200"></div>
        <div className="absolute top-0 h-12 w-12 animate-spin rounded-full border-4 border-blue-600 border-t-transparent"></div>
      </div>
      <div className="text-lg font-medium text-gray-600">{message}</div>
    </div>
  );

  if (!showCard) {
    return (
      <div className={`flex h-full items-center justify-center p-4 ${className}`}>{content}</div>
    );
  }

  return (
    <Card className={`h-full flex-1 overflow-hidden rounded-none lg:rounded-xl ${className}`}>
      <CardContent className="relative flex h-full items-center justify-center p-0">
        {content}
      </CardContent>
    </Card>
  );
}
